<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <div class="index">
    <div class="header">
      <img :src="customReportDto.logoPath | logo_show" class="logo-img" @click="goback">
      <a @click="goback">Back to Home</a>
    </div>
    <div class="search-container">
      <div class="search-ipt">
        <i class="iconfont search-icon">&#xe6d7;</i>
        <Input v-model="chapterParams.keyword" @on-enter="handleRefreshList" placeholder="Search title, content, entity, policy, indication" />
        <Button @click="handleRefreshList">Search</Button>
      </div>
    </div>
    <div class="filter-section">
      <div class="filter-row">
        <div :class="['filter-item', chapterParams.startTime && 'active']" @click="showDateRange = true">
          <span v-if="!chapterParams.startTime">By Date</span>
          <span v-else>{{chapterParams.startTime | time_moment('YYYY/MM/DD')}} - {{chapterParams.endTime | time_moment('YYYY/MM/DD')}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
        <div :class="['filter-item', chapterParams.moduleIds.length && 'active']" @click="showModulePicker = true">
          <span v-if="!chapterParams.moduleIds.length">By Category</span>
          <span v-else>{{chapterParams.moduleIds | dealArrayName(categories, 'id', 'enName')}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
      </div>
    </div>
    <div class="search-result-container">
      <div class="result-list">
        <ul class="content-list">
          <li v-for="item,index in list" :key="index">
            <div class="topic" v-if="item.contentType === 0">
              <div class="title">
                <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/slash.png'" class="slash">
                <a :href="item.srcUrl" target="_blank" v-html="filter.keyWordHighLight(item.enTitle, currentKeyword)"></a>
              </div>
              <div class="desc" v-html="filter.keyWordHighLight(item.enContent, currentKeyword)"></div>
            </div>
            <div class="report" v-if="item.contentType === 2">
              <a class="image" :href="item.srcUrl" target="_blank">
                <img :src="item.logoPath | logo_show" />
              </a>
              <div class="card">
                <div class="card-top">
                  <a :href="item.srcUrl" target="_blank" class="title" v-html="filter.keyWordHighLight(item.enTitle, currentKeyword)"></a>
                  <div class="desc" v-html="filter.keyWordHighLight(item.enContent, currentKeyword)"></div>
                </div>
                <div class="card-btm">
                  <span v-if="item.srcAuthor"><i class="iconfont">&#xe645;</i>来源：{{item.srcAuthor}}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="no-data" v-if="!list.length && !loading">
          <img :src="$store.state.static_img_url + 'pic/newsletter/nodata-icon.png'" />
          <p>No related results</p>
        </div>
        <div class="no-data2" v-if="list.length && !more && !loading">Reached the end!</div>
        <Spin v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>

      <div ref="indexlist-bottom"></div>
    </div>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>

    <van-calendar
      v-model="showDateRange"
      ref="date-range"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      color="#FA5A00"
      allow-same-day
      @select="selectDateRange"
      @open="openCalendar"
    >
      <template slot="title">
        <span>By Date</span>
        <div class="month-btns">
          <van-button size="mini" @click="handleChangeYear('prev')">
            <i class="iconfont-pc30">&#xe639;</i>
          </van-button>
          <van-button size="mini" @click="handleChangeYear('next')">
            <i class="iconfont-pc30">&#xe63a;</i>
          </van-button>
        </div>
      </template>
      <template slot="top-info" slot-scope="row">
        <span v-if="filter.time_moment(row.date, 'YYYY-MM-DD') == filter.time_moment(new Date(), 'YYYY-MM-DD')" class="today">today</span>
      </template>
      <!-- <template slot="bottom-info" slot-scope="row"></template> -->
      <div class="calendar-btns" slot="footer">
        <van-button round @click="clearDateRange" color="#AEAEAE">
          {{!chapterParams.startTime ? 'Close' : 'Clear'}}
        </van-button>
        <van-button round :disabled="!dateRange.length" color="#FA5A00" @click="handleConfirmDateRange">
          {{!dateRange.length ? 'Select End Time' : 'Confirm'}}
        </van-button>
      </div>
    </van-calendar>
    <van-popup v-model="showModulePicker" round position="bottom" @open="openModulePicker">
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="clearModule">Clear</button>
        <button type="button" class="van-picker__confirm" @click="onModuleConfirm">Confirm</button>
      </div>
      <van-checkbox-group v-model="moduleIds" class="categories-checkbox">
        <van-cell-group>
          <van-cell :name="item.id" v-for="item,index in categories" :key="item.id" clickable :title="item.enName" @click="toggle(index)">
            <template slot="right-icon">
              <van-checkbox :name="item.id" ref="checkboxes" checked-color="#FA5A00" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
  </div>
</template>
<script>
import { AchapterInfo, AchapterModuleList, AchapterModuleContentList } from '@/service'
import moment from 'moment'
import filter from 'js/filter'
import { Locale } from 'vant'
import enUs from 'vant/lib/locale/lang/en-US'
Locale.use('en-US', enUs)

export default {
  components: {},
  created() {
    this.chapterParams.keyword = this.$route.query.keyword
      ? decodeURIComponent(this.$route.query.keyword)
      : ''

    if (this.$route.query.uid && this.$route.query.name) {
      this.getDetail()
    } else {
      this.$Message.error('Invalid URL parameter!')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const listbox = this.$refs['indexlist-bottom']
        const listrect = listbox.getBoundingClientRect()
        const listabsoluteTop = listrect.top + scrollTop
        if (
          scrollTop + windowHeight > listabsoluteTop &&
          scrollTop > 0 &&
          !this.loading &&
          this.more
        ) {
          this.handleMore()
        }
      }, 10)
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() {
    return {
      filter,
      pageLoading: true,
      loading: false,
      more: false,
      dateRange: [],
      chapterIds: [],
      categories: [],
      chapterParams: {
        chapterIds: [],
        keyword: '',
        moduleIds: [],
        startTime: '',
        endTime: '',
        getCount: false,
        page: 1,
        size: 20,
        topCreateTime: null,
      },
      customReportDto: {},
      list: [],
      currentKeyword: '',
      topCreateTime: null,

      showDateRange: false,
      minDate: new Date(2014, 0, 1),
      maxDate: new Date(),

      moduleIds: [],
      showModulePicker: false,
    }
  },
  computed: {},
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    /**
     * 获取月报英文基本信息及期刊
     */
    async getDetail() {
      let res = await AchapterInfo(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('Request Error!')
      )
      this.pageLoading = false
      if (res.code === 0) {
        if (res.data.customReportDtoList.length) {
          this.$set(this.$data, 'customReportDto', res.data.customReportDtoList[0])
        }
        if (res.data.chapterDtoList.length) {
          this.chapterIds = res.data.chapterDtoList.map((item) => item.id)
          this.chapterParams.chapterIds = this.chapterIds
          this.getModuleList()
          this.handleRefreshList()
        }
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    async getModuleList() {
      const params = {
        startTime: '',
        endTime: '',
        chapterIds: this.chapterIds,
      }
      let res = await AchapterModuleList(params, (error) => this.$Message.error('Request Error!'))
      if (res.code === 0) {
        this.$set(this.$data, 'categories', res.data.moduleList)
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    async getList() {
      this.loading = true
      this.currentKeyword = this.chapterParams.keyword
      if (!this.currentKeyword) {
        this.list = []
        this.chapterParams.page = 1
        this.loading = false
        return
      }
      this.chapterParams.topCreateTime = this.chapterParams.page == 1 ? null : this.topCreateTime
      let res = await AchapterModuleContentList(this.chapterParams, (error) =>
        this.$Message.error('Request Error!')
      )
      this.loading = false
      if (res.code === 0) {
        this.list = [...this.list, ...res.data.contentDtos]
        this.more = res.data.contentDtos.length == this.chapterParams.size
        if (this.chapterParams.page == 1) this.topCreateTime = res.extraData.topCreateTime
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    handleRefreshList() {
      this.chapterParams.page = 1
      this.list = []
      this.getList()
    },
    handleMore() {
      this.chapterParams.page++
      this.getList()
    },
    goback() {
      const { keyword, ...params } = this.$route.query
      this.$router.push({
        name: 'MEnNewsletter',
        query: params,
      })
    },
    openCalendar() {
      const [start, end] = [this.chapterParams.startTime, this.chapterParams.endTime]
      if (start && end) {
        this.dateRange = [start, end]
        this.$refs['date-range'].reset([
          new Date(moment(start).format('YYYY/MM/DD')),
          new Date(moment(end).format('YYYY/MM/DD')),
        ])
      } else {
        this.dateRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        this.$refs['date-range'].reset([new Date(), new Date()])
      }
      this.handleChangeScrollTop()
    },
    handleChangeScrollTop() {
      this.$nextTick(() => {
        const calendarDom = document.querySelector('.van-calendar__body')
        if (calendarDom) {
          let back = calendarDom.scrollTop
          setTimeout(() => {
            back = calendarDom.scrollTop
            calendarDom.scrollTop = back - 2
          }, 10)
          setTimeout(() => {
            calendarDom.scrollTop = back
          }, 100)
        }
      })
    },
    handleChangeYear(name) {
      const calendarSubtitle = this.$refs['date-range'].$el.querySelector(
        '.van-calendar__header-subtitle'
      )
      if (!calendarSubtitle) return

      let year = parseInt(calendarSubtitle.innerText.split('年')[0])

      // 检查年份限制
      if (name === 'prev' && year <= 2014) return
      if (name === 'next' && year >= new Date().getFullYear()) return

      year = name === 'prev' ? year - 1 : year + 1

      this.$nextTick(() => {
        this.$refs['date-range'].scrollToDate(new Date(year, 0, 1))
        this.handleChangeScrollTop()
      })
    },
    selectDateRange(date) {
      const [start, end] = date
      if (start && end) {
        this.dateRange = [moment(start).format('YYYY-MM-DD'), moment(end).format('YYYY-MM-DD')]
      } else {
        this.dateRange = []
      }
    },
    clearDateRange() {
      if (!this.chapterParams.startTime) {
        this.showDateRange = false
        return
      }
      this.showDateRange = false
      this.chapterParams.startTime = ''
      this.chapterParams.endTime = ''
      this.dateRange = []
      this.handleRefreshList()
    },
    handleConfirmDateRange() {
      this.showDateRange = false
      this.chapterParams.startTime = this.dateRange[0] + ' 23:59:59'
      this.chapterParams.endTime = this.dateRange[1] + ' 00:00:00'
      this.handleRefreshList()
    },
    openModulePicker() {
      this.moduleIds = this.chapterParams.moduleIds
    },
    onModuleConfirm() {
      this.showModulePicker = false
      this.chapterParams.moduleIds = this.moduleIds
      this.handleRefreshList()
    },
    clearModule() {
      this.showModulePicker = false
      this.chapterParams.moduleIds = []
      this.handleRefreshList()
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~mobile/styles/briefReport.stylus'
@import '~mobile/styles/newsletter.stylus'
@import './style/searchNewsletter.styl'
.search-result-container
  padding-top 0
.filter-section .filter-row
  justify-content flex-start
  .filter-item
    &+.filter-item
      margin-left 0.4rem
    &> span
      max-width 3.2rem
      line-height 1.5
</style>